import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import ModalWrapper from './ModalWrapper';
import ModalWrapperBranched from '../ModalWrapper.complete_theme';
export default withFeatureBranch({
    complete_theme: ModalWrapperBranched
})(ModalWrapper);
